

export const Enum =  {
    /*Values for checkboxex*/
    ISBEVERAGE: 1,
    ISCHECKED : 1,
    ISCHECKBOX: 1,
    /*Values for navigation*/
    MENU: 1,
    PEDIDO : 2,
    REGISTRAR: 3,
    LOGIN: 4,
    /*Values for API response */
    APIRESPONSEOK : 200,
    APIRESPONSEREQUESTOK : 201,
    /*Values for modal */
    CONFIRMORDEN :1,
    CONFIRMITEMTOCCART:2,
    VALIDATIONORDEN :3,
    /*Values for order status */
    OPEN : 1,
    INPROGRESS:2,
    ONROUTE : 3, 
    DELIVERED :4,
    CANCELLED : 5, 
    CLOSED: 6
    
}

export default Enum